import React from 'react';
import RadioSelect from '../pure/utils/form/RadioSelect';
import {UserConditionType} from 'records/UserCondition';
import './UserContextSelect.styl';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import {UserContextType} from 'components/triggers/UserContextType';

export default class UserContextSelect extends React.Component {
  changeTypeValue(type, value) {
    this.props.selectedValueChanged(value, null, type);
  }
  render() {
    const {
      userOptions,
      teamOptions,
      managerOptions,
      departmentOptions,
      roleOptions,
      selectedContextType,
      selectedValue,
      contextType,
    } = this.props;
    const includeRecipientOptions = contextType === UserContextType.CALL;
    const includeReviewerOptions = contextType === UserContextType.USER;
    const includeShared = contextType === UserContextType.USER;
    const who = contextType === UserContextType.USER ? 'reviewer' : 'caller';
    const whoUpper = contextType === UserContextType.USER ? 'Reviewer' : 'Caller';

    return (
      <div className="user-context-select">
        <ul>
          <li>
            <RadioSelect
              label={`Anybody is the ${who}`}
              checked={selectedContextType === UserConditionType.ANY_USER}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.ANY_USER)}
            />
          </li>
          <li>
            <RadioSelect
              label={`${whoUpper} is specific person`}
              checked={selectedContextType === UserConditionType.USER}
              options={userOptions.sortBy(x => x.label)}
              value={selectedValue}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.USER)}
              valueChanged={this.props.selectedValueChanged}
              placeholder={'- select user -'}
            />
          </li>
          <li>
            <RadioSelect
              label={`${whoUpper} is in this team`}
              checked={selectedContextType === UserConditionType.TEAM}
              options={teamOptions.sortBy(x => x.label)}
              value={selectedValue}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.TEAM)}
              valueChanged={this.props.selectedValueChanged}
              placeholder={'- select team -'}
            />
          </li>
          <li>
            <RadioSelect
              label={`${whoUpper} has manager`}
              checked={selectedContextType === UserConditionType.MANAGER}
              options={managerOptions.sortBy(x => x.label)}
              value={selectedValue}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.MANAGER)}
              valueChanged={this.props.selectedValueChanged}
              placeholder={'- select manager -'}
            />
          </li>
          <li>
            <RadioSelect
              label={`${whoUpper} is in this department`}
              checked={selectedContextType === UserConditionType.DEPARTMENT}
              options={departmentOptions.sortBy(x => x.label)}
              value={selectedValue}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.DEPARTMENT)}
              valueChanged={this.props.selectedValueChanged}
              placeholder={'- select department -'}
            />
          </li>
          <li>
            <RadioSelect
              label={`${whoUpper} has role`}
              checked={selectedContextType === UserConditionType.ROLE}
              options={roleOptions}
              value={typeof selectedValue === 'string' ? selectedValue.toLowerCase() : ''}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.ROLE)}
              valueChanged={this.props.selectedValueChanged}
              placeholder={'- select role -'}
            />
          </li>
          <li>
            <RadioSelect
              label={`${whoUpper} is me (or any user this rule is shared with)`}
              checked={selectedContextType === UserConditionType.SHARED_ME}
              radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.SHARED_ME)}
            />
          </li>
          {includeShared && (
            <li>
              <RadioSelect
                label={`${whoUpper} is any user this rule is shared with, excluding me`}
                checked={selectedContextType === UserConditionType.SHARED}
                radioClick={() => this.props.selectedContextTypeChanged(UserConditionType.SHARED)}
              />
            </li>
          )}
          {includeRecipientOptions && (
            <li>
              <RadioSelect
                label="Caller is also the reviewer"
                checked={
                  selectedContextType === FeedbackTriggerType.REVIEWER_IS_RECIPIENT &&
                  selectedValue === false
                }
                radioClick={() =>
                  this.changeTypeValue(FeedbackTriggerType.REVIEWER_IS_RECIPIENT, false)
                }
              />
            </li>
          )}
          {includeRecipientOptions && (
            <li>
              <RadioSelect
                label="Caller is anybody except the reviewer"
                checked={
                  selectedContextType === FeedbackTriggerType.REVIEWER_IS_RECIPIENT &&
                  selectedValue === true
                }
                radioClick={() =>
                  this.changeTypeValue(FeedbackTriggerType.REVIEWER_IS_RECIPIENT, true)
                }
              />
            </li>
          )}
          {includeReviewerOptions && (
            <li>
              <RadioSelect
                label="Caller is also the reviewer"
                checked={
                  selectedContextType === UserConditionType.REVIEWER_IS_CALLER &&
                  selectedValue === false
                }
                radioClick={() => this.changeTypeValue(UserConditionType.REVIEWER_IS_CALLER, false)}
              />
            </li>
          )}
          {includeReviewerOptions && (
            <li>
              <RadioSelect
                label="Caller is anybody except the reviewer"
                checked={
                  selectedContextType === UserConditionType.REVIEWER_IS_CALLER &&
                  selectedValue === true
                }
                radioClick={() => this.changeTypeValue(UserConditionType.REVIEWER_IS_CALLER, true)}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}
